import React from 'react'
import styled from 'styled-components'
import Dialog from '@material-ui/core/Dialog'
import Grow from '@material-ui/core/Grow'
import { getSpacingSelector } from '@signal/theme/selectors'

type PromptDialogType = React.ComponentType<{
  $zIndexOverride?: number
  TransitionComponent: React.ComponentType<unknown>
}>

export const PromptDialog = styled<PromptDialogType>(
  Dialog as PromptDialogType
).attrs(() => ({
  TransitionComponent: Grow
}))`
  ${({ $zIndexOverride }) =>
    $zIndexOverride ? `z-index: ${$zIndexOverride} !important;` : ''}

  & .MuiPaper-root {
    padding: ${getSpacingSelector(2)}px;
  }
`

export const DescriptionWrapper = styled.div`
  display: flex;
  align-items: center;

  & svg {
    display: block;
    font-size: 64px !important;
    margin-right: ${getSpacingSelector(2)}px;
  }
`
